import React from 'react';
import { CircleNotch as Loader2 } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';
interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'default' | 'lg' | 'xl';
}
export function Spinner({
  className,
  size = 'default',
  ...props
}: SpinnerProps) {
  return <div className={cn('flex items-center justify-center', className)} {...props} data-id="element-2862">
      <Loader2 className={cn('animate-spin text-primary', {
      'h-4 w-4': size === 'sm',
      'h-6 w-6': size === 'default',
      'h-8 w-8': size === 'lg',
      'h-12 w-12': size === 'xl'
    })} data-id="element-2863" />
    </div>;
}